import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import ReactModal from 'react-modal';
import {Provider} from 'react-redux';
import App from './App';
import {store} from './store';

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root element not found');

ReactModal.setAppElement(rootElement);
const root = createRoot(rootElement);
root.render(
    <Provider store={store}>
        <StrictMode>
            <App/>
        </StrictMode>
    </Provider>
);
